import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";

function ColumnUpgrade({ width }) {
  const storeAuth = useSelector( state => state.storeAuth );
  const onClick = () => { storeAuth.linkPro(); }
  return (
    <div style={{ width, textAlign: `-webkit-center`, zIndex: 50}}>
      <span className={`upgrade`} onClick={onClick}>Upgrade</span>
    </div>
  )
}

ColumnUpgrade.propTypes = {
  width: PropTypes.number.isRequired
}

export default ColumnUpgrade;
